import { useState, useRef, useEffect } from "react";
import { Form, FormGroup } from "react-bootstrap";
import SectionRow from "components/PantallasEdit/SectionRow/SectionRow";
import { Simplebar } from "components";
import { AnimatedIconButton } from "components/AnimatedIconButton/AnimatedIconButton";
import useExceptionHandler from "hooks/useExceptionHandler";
import uuid from "react-uuid";

function Exportar({
  PROPIEDADES_EXPORTAR,
  showExportar,
  setShowExportar,
  where,
  showLoading,
  hideLoading,
  exportarCallBack,
  serialize = false,
}) {
  const ref = useRef(null);
  const [propiedadesSeleccionadas, setPropiedadesSeleccionadas] = useState([]);
  const { handleException } = useExceptionHandler();
  const [componentKey, setComponentKey] = useState();
  const [allSelected, setAllSelected] = useState(false);

  useEffect(() => {
    setComponentKey(uuid().substring(0, 4));
  }, []);

  useEffect(() => {
    setAllSelected(false);
  }, [showExportar]);

  const toggleSelectAll = () => {
    if (allSelected) {
      deselectAll();
    } else {
      selectAll();
    }
    setAllSelected(!allSelected);
  };

  const setCheckedProp = (e) => {
    const { name, checked } = e.target;
    const [property, descripcion] = name.split("*");
    let props = [...propiedadesSeleccionadas];
    if (checked) {
      props = [...props, { Descripcion: descripcion, Property: property }];
    } else {
      props = props.filter(function (element) {
        return element.Property !== property;
      });
    }
    setPropiedadesSeleccionadas(props);
  };

  const exportar = () => {
    showLoading();
    
    const whereExportar = {
      ...where,
      FechaInicio: where.RangoFechas?.fechaInicio,
      FechaFin: where.RangoFechas?.fechaFin,
    };

    exportarCallBack({
      PROPIEDADES_EXPORTAR: propiedadesSeleccionadas,
      Where: serialize ? JSON.stringify(whereExportar) : whereExportar,
    })
      .then(async (res) => {
        const link = document.createElement("a");
        const result = await res.blob;
        link.target = "_blank";
        link.download = `${uuid()}.xls`;
        link.href = URL.createObjectURL(result);
        link.click();
      })
      .catch((error) => {
        handleException(error);
      })
      .finally(() => {
        hideLoading();
      });
  };

  function selectAll() {
    const checkBoxes = document.querySelectorAll(
      `.ck${componentKey} input[type='checkbox']`
    );

    let props = [];
    for (var i = 0; i < checkBoxes.length; i++) {
      if (checkBoxes[i].type == "checkbox") {
        checkBoxes[i].checked = true;
        const [property, descripcion] = checkBoxes[i].name.split("*");

        if (checkBoxes[i].checked) {
          props = [...props, { Descripcion: descripcion, Property: property }];
        } else {
          props = props.filter(function (element) {
            return element.Property !== property;
          });
        }
      }
      setPropiedadesSeleccionadas(props);
    }
  }

  function deselectAll() {
    const checkBoxes = document.querySelectorAll(
      `.ck${componentKey} input[type='checkbox']`
    );
    let props = [];
    for (var i = 0; i < checkBoxes.length; i++) {
      if (checkBoxes[i].type == "checkbox") {
        checkBoxes[i].checked = false;
        const [property, descripcion] = checkBoxes[i].name.split("*");

        if (checkBoxes[i].checked) {
          props = [...props, { Descripcion: descripcion, Property: property }];
        } else {
          props = props.filter(function (element) {
            return element.Property !== property;
          });
        }
      }
      setPropiedadesSeleccionadas(props);
    }
  }

  return (
    <Simplebar
      size="sm"
      ref={ref}
      backdrop={true}
      placement={"end"}
      portal={false}
      visible={showExportar}
      setShow={(e) => {
        setShowExportar(e);
      }}
      useLoading={true}
      title="Exportar a Excel"
      btnLeft={{
        show: false,
      }}
      btnRight={{
        show: true,
        message: "Imprimir",
        isComponent: true,
        size: "45px",
        height: "24px",
        with: "24px",
        iconName: "check",
        func: () => {
          exportar();
          setShowExportar(false);
        },
      }}
    >
      <div style={{ height: "100%", overflow: "hidden" }}>
      <FormGroup className={`ck${componentKey}`}>
        <div
          className="mb-3"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            paddingBottom: "8px",
            borderBottom: "1px solid #eee",
          }}
        >
          <span style={{ color: "#999999", fontSize: "1rem" }}>
            Seleccionar los campos a exportar
          </span>
          <AnimatedIconButton
            size="38px"
            height="20px"
            width="20px"
            iconName="select_all_exportar"
            message="Seleccionar / deseleccionar todos"
            onClick={toggleSelectAll}
          />
        </div>

        <div style={{ overflowY: "auto", overflowX: "hidden", maxHeight: "calc(100vh - 160px)" }}>
          {PROPIEDADES_EXPORTAR &&
            PROPIEDADES_EXPORTAR?.map((propiedad) => {
              return (
                <SectionRow colspan={1}>
                  <Form.Check
                    className="ml-5 "
                    type="checkbox"
                    aria-label={propiedad.label}
                    key={`${propiedad.value}*${propiedad.label}`}
                    name={`${propiedad.value}*${propiedad.label}`}
                    onChange={setCheckedProp}
                  />
                  <label
                    htmlFor={`ck${propiedad.label}`}
                    style={{ marginRight: "15px", marginTop: "3px" }}
                  >
                    {propiedad.label}
                  </label>
                </SectionRow>
              );
            })}
        </div>
      </FormGroup>
      </div>
    </Simplebar>
  );
}

export default Exportar;
